import moment from 'moment'

const initialState = {
  date: moment().format("YYYY-MM-DD"),
  view: 'agenda'
}

export function dateFilterReducer(state = initialState, { type, payload }){
  switch(type){
    case "UPDATE_FILTER_DATE":
    return {
      ...state,
      date: payload,
    }
    case "UPDATE_VIEW":
      return {
        ...state,
        view: payload,
      }
    default:
      return state
  }
}